export default __webpack_public_path__ + "static/media/undraw_crypto.f3c9d093.svg";